// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.selected {
  color: rgb(255, 255, 255);
  background-color: rgb(53, 151, 236);
  border-color: rgb(53, 151, 236);
}

div.selected > label {
  color: rgb(255, 255, 255);
}

div.selected img {
  filter: brightness(0) invert(1);
}


.aud-tabs .panel .btn {
  background: rgb(248, 248, 248);
  color: rgb(159, 158, 172);
  border-radius: 6px 6px 0 0;
  font-size: 14px;
  margin-right: 2px;
  padding: 15px 26px;
  border: rgb(233, 233, 240) solid 1px;
  border-bottom: none;
}

.aud-tabs .panel .btn.active {
  background: rgb(59, 134, 255);
  color: rgb(255, 255, 255);
}

.aud-tabs .panel.border-panel {
  border-bottom: rgb(233, 233, 240) solid 1px;
}

.chips {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 2rem;
  padding-left: 1.5rem;
  width: 75%;
}

.chips:last-child {
  margin-bottom: 0.5rem;
}

.chip-container {
  align-items: center;
  border: 2px solid rgb(186, 186, 186);
  border-radius: 27px;
  display: inline-flex;
  height: 2rem;
  padding: 0 1.5rem 0 1rem;
}

.chip-container > label {
  margin: 0;
  display: flex;
  gap: 0.45rem;
  flex-direction: row;
  align-items: center;
}

.chips-heading {
  font-weight: bold;
  margin-bottom: 0.75rem;
  width: 100%;
}

.label-heading {
  font-size: 1rem !important;
  font-style: normal;
  font-weight: normal !important;
  margin-bottom: 0.5rem;
  text-transform: none !important;
}

.location-tags {
  margin-top: 1rem;
}

.location-tags-container {
  margin-top: 0.5rem;
  padding-left: 0 !important;
}

.no-chips-selected p {
  font-weight: bold;
  margin-left: 1.5rem;
}

.summary-list, .yourwebsite-tab {
  color: rgb(67, 66, 93);
}

.summary-list h5, .yourwebsite-tab h5 {
  font-size: 17px;
  border-bottom: 1px solid rgb(211, 211, 211);
  padding-bottom: 10px;
}

.yourwebsite-tab .col-sm-12 {
  line-height: 26px;
}

.summary-list label {
  font-weight: 700;
  margin-bottom: 0;
}

.summary-list label + div {
  font-style: italic;
  padding-left: 4px;
}

.summary-list h4 {
  border-bottom: rgb(77, 79, 92) solid 4px;
  font-weight: 700;
  font-size: 20px;
}

.summary-list ul {
  margin-bottom: 0;
}

.summary-list ul li {
  font-style: italic;
}

.btn-secondary:not(:disabled):not(.disabled):active {
  box-shadow: none;
  background: rgb(255, 255, 255);
  color: rgb(173, 173, 173);
  border: 1px solid rgb(211, 211, 211);
}

.location-list-header {
  border-bottom: 1px rgb(0, 0, 0) solid;
}

.location-review-panel {
  border: 1px rgb(0, 0, 0) solid;
  padding: 10px;
  margin-top: 10px;
}

.upload-img-thumbnail {
  max-width: 80px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/customer/intakes/add-intakes-data/local-listings/review-ll.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;;AAGA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["div.selected {\n  color: rgb(255, 255, 255);\n  background-color: rgb(53, 151, 236);\n  border-color: rgb(53, 151, 236);\n}\n\ndiv.selected > label {\n  color: rgb(255, 255, 255);\n}\n\ndiv.selected img {\n  filter: brightness(0) invert(1);\n}\n\n\n.aud-tabs .panel .btn {\n  background: rgb(248, 248, 248);\n  color: rgb(159, 158, 172);\n  border-radius: 6px 6px 0 0;\n  font-size: 14px;\n  margin-right: 2px;\n  padding: 15px 26px;\n  border: rgb(233, 233, 240) solid 1px;\n  border-bottom: none;\n}\n\n.aud-tabs .panel .btn.active {\n  background: rgb(59, 134, 255);\n  color: rgb(255, 255, 255);\n}\n\n.aud-tabs .panel.border-panel {\n  border-bottom: rgb(233, 233, 240) solid 1px;\n}\n\n.chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  padding-left: 1.5rem;\n  width: 75%;\n}\n\n.chips:last-child {\n  margin-bottom: 0.5rem;\n}\n\n.chip-container {\n  align-items: center;\n  border: 2px solid rgb(186, 186, 186);\n  border-radius: 27px;\n  display: inline-flex;\n  height: 2rem;\n  padding: 0 1.5rem 0 1rem;\n}\n\n.chip-container > label {\n  margin: 0;\n  display: flex;\n  gap: 0.45rem;\n  flex-direction: row;\n  align-items: center;\n}\n\n.chips-heading {\n  font-weight: bold;\n  margin-bottom: 0.75rem;\n  width: 100%;\n}\n\n.label-heading {\n  font-size: 1rem !important;\n  font-style: normal;\n  font-weight: normal !important;\n  margin-bottom: 0.5rem;\n  text-transform: none !important;\n}\n\n.location-tags {\n  margin-top: 1rem;\n}\n\n.location-tags-container {\n  margin-top: 0.5rem;\n  padding-left: 0 !important;\n}\n\n.no-chips-selected p {\n  font-weight: bold;\n  margin-left: 1.5rem;\n}\n\n.summary-list, .yourwebsite-tab {\n  color: rgb(67, 66, 93);\n}\n\n.summary-list h5, .yourwebsite-tab h5 {\n  font-size: 17px;\n  border-bottom: 1px solid rgb(211, 211, 211);\n  padding-bottom: 10px;\n}\n\n.yourwebsite-tab .col-sm-12 {\n  line-height: 26px;\n}\n\n.summary-list label {\n  font-weight: 700;\n  margin-bottom: 0;\n}\n\n.summary-list label + div {\n  font-style: italic;\n  padding-left: 4px;\n}\n\n.summary-list h4 {\n  border-bottom: rgb(77, 79, 92) solid 4px;\n  font-weight: 700;\n  font-size: 20px;\n}\n\n.summary-list ul {\n  margin-bottom: 0;\n}\n\n.summary-list ul li {\n  font-style: italic;\n}\n\n.btn-secondary:not(:disabled):not(.disabled):active {\n  box-shadow: none;\n  background: rgb(255, 255, 255);\n  color: rgb(173, 173, 173);\n  border: 1px solid rgb(211, 211, 211);\n}\n\n.location-list-header {\n  border-bottom: 1px rgb(0, 0, 0) solid;\n}\n\n.location-review-panel {\n  border: 1px rgb(0, 0, 0) solid;\n  padding: 10px;\n  margin-top: 10px;\n}\n\n.upload-img-thumbnail {\n  max-width: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
